<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Add/Edit FeedStock</h4>
    <div class="content-block">To add new, if the ID field does not show “Select…”, click the X after the ID that is
        displaying, type a name in the Name field and notes, (optional), then click the Save button</div>
    <div *ngIf="feedstocks" class="content-block">
        <form class="login-form" (submit)="handleSubmit($event)">

            <dx-form id="form" [colCount]="6" [(formData)]="feedstock">
                <dxi-item dataField="feedstockId" [colSpan]="2">
                    <dx-select-box #selectBox [items]="feedstocks" searchEnabled="true"
                        (onValueChanged)="onFeedstockChange($event)" showClearButton="true" displayExpr="feedstockName"
                        [(value)]="feedstock.feedstockId" valueExpr="feedstockId">
                    </dx-select-box>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item dataField="feedstockName" editorType="dxTextBox" [colSpan]="2"
                    [editorOptions]="{ value:selectBox.text ? selectBox.text: '' }">
                    <dxi-validation-rule type="required" message="FeedStock is required">
                    </dxi-validation-rule>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item dataField="note" editorType="dxTextArea" [colSpan]="2">

                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                <dxi-item itemType="button" [colSpan]="2"
                    [buttonOptions]="{ text: 'Save', type:'success', useSubmitBehavior: true }">
                </dxi-item>
            </dx-form>
        </form>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>